import {createAction} from '@reduxjs/toolkit'
import {DOWNLOAD_TICKETS_BUTTON_NAMES} from '@wix/wix-events-commons-statics'

export const downloadTickets = createAction('DOWNLOAD_TICKETS', (appleWallet?: boolean) => ({
  payload: {
    buttonName: appleWallet ? DOWNLOAD_TICKETS_BUTTON_NAMES.APPLE_WALLET : DOWNLOAD_TICKETS_BUTTON_NAMES.PDF,
  },
}))
